import { render, staticRenderFns } from "./CommonSpinner.vue?vue&type=template&id=934fbef0&scoped=true"
import script from "./CommonSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonSpinner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommonSpinner.vue?vue&type=style&index=0&id=934fbef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934fbef0",
  null
  
)

export default component.exports